import { l } from '@manychat/manyui'

import { Keyword } from 'apps/keywords/keywordsInterfaces'
import { getKeywordStringPreview } from 'apps/keywords/lib/getKeywordStringPreview'
import { ConditionTypeLabels, ConditionTypes } from 'apps/keywords/models/KeywordRule/constants'
import { ConverterRule } from 'common/builder/components/chart/FlowChart/lib/types'
import {
  FlowChartTrigger,
  FlowChartTriggerIconType,
} from 'common/builder/components/chart/FlowChart/types/FlowChartTrigger'
import { getTriggerConfig } from 'common/builder/utils/getTriggerConfig'
import { isTriggerInteractive } from 'common/builder/utils/isTriggerInteractive'
import { TriggerType } from 'common/flow/constants/TriggerType'
import { IFlowTrigger } from 'common/flow/flowInterfaces'

export const KeywordGenericTriggerConverterRule: ConverterRule<IFlowTrigger, FlowChartTrigger> = {
  predicate: (entity: IFlowTrigger) => entity?.triggerType === TriggerType.KEYWORD,
  convert: (entity: Keyword) => {
    const triggerConfig = getTriggerConfig(entity)

    const isThumbsUp =
      entity.keyword_rules.length === 1 &&
      entity.keyword_rules[0].condition === ConditionTypes.THUMBS_UP

    const text = isThumbsUp
      ? l.getString(ConditionTypeLabels[ConditionTypes.THUMBS_UP])
      : getKeywordStringPreview(entity.keyword_rules)

    const trigger: FlowChartTrigger = {
      id: entity.triggerId,
      icon: {
        type: FlowChartTriggerIconType.ICON,
        icon: triggerConfig?.icon || null,
      },
      title: l.getString(triggerConfig?.description) || l.translate('Empty'),
      subtitle: [text],
      subtitleIcon: null,
      isActive: entity.enabled,
      isInteractive: isTriggerInteractive(entity),
    }

    return trigger
  },
}
